import React, { useContext, useState } from 'react';
import { Nav, Navbar, Button, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { storeContext } from '../Store/storeContext';
import { AuthLogout } from '../utils/NewAuthService';

const NavBarComp = ({ islogin, name, email }) => {
  const [state] = useContext(storeContext);
  const [loginSpiner, setLoginSpiner] = useState(false);
  const logout = () => {
    setLoginSpiner(true);
    const refreshToken = JSON.parse(localStorage.getItem('tokens')).refresh.token;
    AuthLogout(refreshToken)
      .then((response) => {
        window.location.href = '/';
        localStorage.removeItem('tokens');
        localStorage.removeItem('user');
        setLoginSpiner(false);
      })
      .catch((error) => {
        console.error(error);
        setLoginSpiner(false);
      });
  };
  return (
    <>
      <Navbar expand='lg' collapseOnSelect bg='dark' variant='dark'>
        <Navbar.Brand>UTECH Portal</Navbar.Brand>
        <Navbar.Toggle aria-controls='navbarScroll' />
        <Navbar.Collapse id='navbarScroll'>
          <Nav>
            <Link className='nav-link' to='/sepratecourses'>
              All Courses
            </Link>

            <Link className='nav-link' to={state.currentCourse}>
              {state.currentCourse.split('/')[3]}
            </Link>
          </Nav>

          <Nav className='ml-auto'>
            <Navbar.Text className='mx-3 text-white'>
              Welcome , {name ? name : email.split('@')[0]}
            </Navbar.Text>
            <Button hidden={!islogin} onClick={logout} variant='danger'>
              {loginSpiner ? (
                <Spinner size='sm' animation='border'></Spinner>
              ) : (
                'Logout'
              )}
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default withRouter(NavBarComp);
